import { render, staticRenderFns } from "./serviceIndex.vue?vue&type=template&id=4b423d47&scoped=true"
import script from "./serviceIndex.vue?vue&type=script&lang=js"
export * from "./serviceIndex.vue?vue&type=script&lang=js"
import style0 from "./serviceIndex.vue?vue&type=style&index=0&id=4b423d47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b423d47",
  null
  
)

export default component.exports